"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthNumberEnum = exports.ENG_MONTHS = exports.DayNumberEnum = exports.ENG_DAYS = void 0;
var ENG_DAYS;
(function (ENG_DAYS) {
    ENG_DAYS["SUNDAY"] = "sunday";
    ENG_DAYS["MONDAY"] = "monday";
    ENG_DAYS["TUESDAY"] = "tuesday";
    ENG_DAYS["WEDNESDAY"] = "wednesday";
    ENG_DAYS["THURSDAY"] = "thursday";
    ENG_DAYS["FRIDAY"] = "friday";
    ENG_DAYS["SATURDAY"] = "saturday";
})(ENG_DAYS || (exports.ENG_DAYS = ENG_DAYS = {}));
var DayNumberEnum;
(function (DayNumberEnum) {
    DayNumberEnum[DayNumberEnum["SUN"] = 0] = "SUN";
    DayNumberEnum[DayNumberEnum["MON"] = 1] = "MON";
    DayNumberEnum[DayNumberEnum["TUE"] = 2] = "TUE";
    DayNumberEnum[DayNumberEnum["WED"] = 3] = "WED";
    DayNumberEnum[DayNumberEnum["THU"] = 4] = "THU";
    DayNumberEnum[DayNumberEnum["FRI"] = 5] = "FRI";
    DayNumberEnum[DayNumberEnum["SAT"] = 6] = "SAT";
})(DayNumberEnum || (exports.DayNumberEnum = DayNumberEnum = {}));
var ENG_MONTHS;
(function (ENG_MONTHS) {
    ENG_MONTHS[ENG_MONTHS["JAN"] = 0] = "JAN";
    ENG_MONTHS[ENG_MONTHS["FEB"] = 1] = "FEB";
    ENG_MONTHS[ENG_MONTHS["MAR"] = 2] = "MAR";
    ENG_MONTHS[ENG_MONTHS["APR"] = 3] = "APR";
    ENG_MONTHS[ENG_MONTHS["MAY"] = 4] = "MAY";
    ENG_MONTHS[ENG_MONTHS["JUN"] = 5] = "JUN";
    ENG_MONTHS[ENG_MONTHS["JUL"] = 6] = "JUL";
    ENG_MONTHS[ENG_MONTHS["AUG"] = 7] = "AUG";
    ENG_MONTHS[ENG_MONTHS["SEP"] = 8] = "SEP";
    ENG_MONTHS[ENG_MONTHS["OCT"] = 9] = "OCT";
    ENG_MONTHS[ENG_MONTHS["NOV"] = 10] = "NOV";
    ENG_MONTHS[ENG_MONTHS["DEC"] = 11] = "DEC";
})(ENG_MONTHS || (exports.ENG_MONTHS = ENG_MONTHS = {}));
var MonthNumberEnum;
(function (MonthNumberEnum) {
    MonthNumberEnum[MonthNumberEnum["JAN"] = 0] = "JAN";
    MonthNumberEnum[MonthNumberEnum["FEB"] = 1] = "FEB";
    MonthNumberEnum[MonthNumberEnum["MAR"] = 2] = "MAR";
    MonthNumberEnum[MonthNumberEnum["APR"] = 3] = "APR";
    MonthNumberEnum[MonthNumberEnum["MAY"] = 4] = "MAY";
    MonthNumberEnum[MonthNumberEnum["JUN"] = 5] = "JUN";
    MonthNumberEnum[MonthNumberEnum["JUL"] = 6] = "JUL";
    MonthNumberEnum[MonthNumberEnum["AUG"] = 7] = "AUG";
    MonthNumberEnum[MonthNumberEnum["SEP"] = 8] = "SEP";
    MonthNumberEnum[MonthNumberEnum["OCT"] = 9] = "OCT";
    MonthNumberEnum[MonthNumberEnum["NOV"] = 10] = "NOV";
    MonthNumberEnum[MonthNumberEnum["DEC"] = 11] = "DEC";
})(MonthNumberEnum || (exports.MonthNumberEnum = MonthNumberEnum = {}));
